<template>
    <rkm-overlay>
        <template v-if="centroCusto.setor.tipoId === enums.setorTipo.RECEPCAO">
            <rkm-layout-body title="Recepção">
                <template v-slot:actions>
                    <rkm-button
                        @click="exit"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        v-if="hasPermissaoAtualizacaoCadastroPaciente"
                        @click="handleBuscarDadosPacienteIntegracaoCns"
                        color="info"
                    >
                        Buscar dados do paciente no CADSUS
                    </rkm-button>

                    <rkm-button
                        @click="$refs.Form.save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>

                <rkm-layout-content>
                    <Form
                        :fila-id="filaId"
                        @loaded="loaded"
                        @redirect="redirect"
                        @saved="saved"
                        @selected="selected"
                        ref="Form"
                    />
                </rkm-layout-content>

                <ModalIntegracaoCns
                    @update="handleIntegracaoCnsUpdate"
                    ref="ModalIntegracaoCns"
                />
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Recepção">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>RECEPÇÃO</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/ambulatorio/recepcao/Form'
import ModalIntegracaoCns from '@/components/integracao/cns/components/busca//Modal'

// Enums.
import classificacao from '@/enums/cadastro/paciente/classificacao'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'

// Mixins.
import {error, repository, unmask} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        Form,
        ModalIntegracaoCns,
    },
    computed: {
        ...mapGetters({centroCusto: 'getCentroCusto'}),
        hasPermissaoAtualizacaoCadastroPaciente() {
            let hasPermissao = false

            if (this.additionals && this.additionals.permissoesAtualizacaoCadastroPaciente) {
                if (this.paciente && this.paciente.classificacaoId === this.enums.classificacao.MUNICIPE && this.additionals.permissoesAtualizacaoCadastroPaciente.municipe) {
                    hasPermissao = true
                }
                else if (this.paciente && this.paciente.classificacaoId === this.enums.classificacao.PROVISORIO && this.additionals.permissoesAtualizacaoCadastroPaciente.provisorio) {
                    hasPermissao = true
                }
                else if (this.paciente && this.paciente.classificacaoId === this.enums.classificacao.OUTRO_MUNICIPIO && this.additionals.permissoesAtualizacaoCadastroPaciente.outroMunicipio) {
                    hasPermissao = true
                }
            }

            return hasPermissao
        },
    },
    created() {
        this.setShowExitFormConfirmation()

        this.repositories = {
            fila: this.getConectaSusRepository('ambulatorio.fila'),
        }
    },
    data: () => ({
        additionals: null,
        enums: {classificacao, setorTipo},
        paciente: null,
    }),
    methods: {
        ...mapActions([
            'setLoading',
            'setShowExitFormConfirmation',
            'unsetLoading',
            'unsetShowExitFormConfirmation',
        ]),
        redirectToList() {
            this.$router.push('/ambulatorio/recepcao/index')
        },
        redirect() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        loaded(value) {
            this.additionals = value.additionals
        },
        selected(value) {
            this.paciente = value
        },
        saved() {
            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        exit() {
            if (this.filaId) {
                this.showExitConfirmation(async () => {
                    this.setLoading()

                    return this.repositories.fila.sendBack(this.filaId)
                        .then(() => {
                            this.unsetShowExitFormConfirmation()
                            this.redirectToList()
                        })
                        .finally(() => this.unsetLoading())
                }, this.handleError)
            } else {
                this.redirectToList()
            }
        },
        handleBuscarDadosPacienteIntegracaoCns() {
            const params = {
                id: this.paciente.cidadaoId,
                nome: this.paciente.nome,
                dataNascimento: this.paciente.dataNascimento,
                nomeMae: this.paciente.nomeMae,
                cns: this.paciente.cns ? this.unMaskCns(this.paciente.cns) : null,
                cpf: this.paciente.cpf ? this.unMaskCpf(this.paciente.cpf) : null,
            }

            this.$refs.ModalIntegracaoCns.open(params)
        },
        handleIntegracaoCnsUpdate(item) {
            Object.assign(this.paciente, {
                ...item,
                dataNascimento: item.dataNascimento ? this.others.moment(item.dataNascimento).format('DD/MM/YYYY') : null,
                idade: item.idadeFormatada,
            })
        },
    },
    mixins: [error, repository, unmask],
    props: {
        filaId: {type: Number},
    },
}
</script>